'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import { StarRating } from '@7f-ui/components/star-rating/star-rating';
import { formatGermanNumber } from '@utils/utils-format';
import { RatingStars } from 'src/shared/composites/trusted-shops/rating-stars';
import { RatingValue } from 'src/shared/composites/trusted-shops/rating-value';
import { useAppExperienceReviews } from '../_hooks/use-app-experience-reviews';
type AppExperienceRatingProps = {
  publicId: number;
  compactCount?: boolean;
  /** "base" = smaller row for the mobile title (Figma rating symbol at 100 %) */
  size?: 'default' | 'base';
  className?: string;
  /** Classes for the outermost element (the button when clickable), e.g. to hide it per breakpoint */
  rootClassName?: string;
  onClick?: () => void;
};
export function AppExperienceRating(t0) {
  const $ = _c(16);
  const {
    publicId,
    compactCount: t1,
    size: t2,
    className,
    rootClassName,
    onClick
  } = t0;
  const compactCount = t1 === undefined ? false : t1;
  const size = t2 === undefined ? "default" : t2;
  const {
    data
  } = useAppExperienceReviews(publicId);
  if (!data?.count) {
    return null;
  }
  let countLabel = data.count;
  if (!compactCount) {
    countLabel = data.count === 1 ? "1 Bewertung" : `${formatGermanNumber(data.count)} Bewertungen`;
  }
  const t3 = size === "base" ? "gap-[7px]" : "gap-2 font-body-copy";
  const t4 = !onClick && rootClassName;
  let t5;
  if ($[0] !== className || $[1] !== t3 || $[2] !== t4) {
    t5 = cx("flex items-center", t3, className, t4);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = `Trusted Shops: ${formatGermanNumber(data.rating)} von 5, ${data.count === 1 ? "eine Bewertung" : `${formatGermanNumber(data.count)} Bewertungen`}`;
  let t7;
  if ($[4] !== countLabel || $[5] !== data.rating || $[6] !== size) {
    t7 = size === "base" ? <><RatingStars rating={data.rating} /><RatingValue rating={data.rating} className="font-heading4-small" /><span className="font-base-copy">({countLabel})</span></> : <><span aria-hidden={true}><StarRating stars={data.rating} hideLabel={true} yellow={true} /></span><RatingValue rating={data.rating} className="font-heading4 text-[20px]" /><span className="font-base-copy">({countLabel})</span></>;
    $[4] = countLabel;
    $[5] = data.rating;
    $[6] = size;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
    t8 = <div className={t5} role="img" aria-label={t6}>{t7}</div>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const rating = t8;
  let t9;
  if ($[12] !== onClick || $[13] !== rating || $[14] !== rootClassName) {
    t9 = onClick ? <button type="button" onClick={onClick} aria-label="Alle Bewertungen anzeigen" aria-haspopup="dialog" className={cx("cursor-pointer rounded-sm focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-4", rootClassName)}>{rating}</button> : rating;
    $[12] = onClick;
    $[13] = rating;
    $[14] = rootClassName;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}